import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NewSharedModule } from 'app/new_shared/new-shared.module';
import { MatSidenavModule } from '@angular/material/sidenav';

import { SimpleNotificationsModule } from 'angular2-notifications';
import { ExternalContentWrapperComponent } from './external-content-wrapper/external-content-wrapper.component';
import { ExternalContentNavDropdownComponent } from './external-content-nav-dropdown/external-content-nav-dropdown.component';
import { PipesModule } from 'app/modules/pipes/pipes.module';

@NgModule({
imports: [
    RouterModule,
    NewSharedModule,
    MatSidenavModule,
    PipesModule,

  ],
  providers: [],
  declarations: [
    ExternalContentWrapperComponent,
    ExternalContentNavDropdownComponent,
  ],
  exports: [
    ExternalContentWrapperComponent,
   ]
})
export class ExternalContentModule { }
